import { useApiPrivateRequest } from "../../../shared/hooks/useApi";

export const useGetAvailableClients = () => {
  const {
    data: availableClients,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<string[]>((response) => response);

  const getAvailableClients = async () => {
    await call("/admin/llm/clients", "GET");
  };

  return {
    availableClients,
    getAvailableClients,
    isLoading,
    isFailed,
  };
};
